export default {
  HOUR: 'hour',

  // Private
  DOLLAR: 'dollar',
  PERCENT: 'percent',
};
